import {getStore, removeItem, checkStatusError} from '../util';
import {ValidationError} from '../util/errors';

const getAllItems = async (from, to, includeCancel) => {
    const user = getStore('user');
    if (!user) {
      throw new ValidationError('token is not found');
      }
      let url = `/api/admin/actions?from=${from}&to=${to}`;
      if (includeCancel) {
        url += `&includeCancel=true`
      }
  const response =  await fetch(url, {
         headers: {
            'Content-Type': 'application/json',
            'x-access-token': user.accessToken
        }
    });
    if (response.ok) {
        return response.json();
    }
    throw response;
};


const cancelBook = async (id, amount) => {
    const user = getStore('user');
    if (!user) {
      throw new ValidationError('token is not found');
    }
    const response =  await fetch(`/api/admin/booking/${id}` ,{
        method: 'DELETE',
        headers: {
           'Content-Type': 'application/json',
           'x-access-token': user.accessToken
       },
       body: JSON.stringify({amount: amount})
   });
   if (response.ok) {
        return ;
    }
    throw response;

}
const getBookingById = async (id) => {
    const user = getStore('user');
    if (!user) {
      throw new ValidationError('token is not found');
      }
    const response =  await fetch(`/api/admin/booking/${id}`, {
        headers: {
            'Content-Type': 'application/json',
            'x-access-token': user.accessToken
        }
    });
    if (response.ok) {
        return response.json();
    }
    throw response;
};

const updateStatus = async (id, status, notes, advance, checks) => {
    const user = getStore('user');
    if (!user) {
      throw new ValidationError('token is not found');
    }
    const response =  await fetch(`/api/admin/booking/${id}/status` ,{
        method: 'PUT',
        headers: {
           'Content-Type': 'application/json',
           'x-access-token': user.accessToken
       },
       body: JSON.stringify({status: status, notes:notes, advance:advance, checks})
   });
   if (response.ok) {
        return response.json();
    }
    throw response;
}

const completeCheckIn = async (id, checks) => {
    const user = getStore('user');
    if (!user) {
      throw new ValidationError('token is not found');
    }
    const response =  await fetch(`/api/admin/booking/${id}/complete-checkin` ,{
        method: 'PUT',
        headers: {
           'Content-Type': 'application/json',
           'x-access-token': user.accessToken
       },
       body: JSON.stringify({checks: checks})
   });
   if (response.ok) {
        return response.json();
    }
    throw response;
}

const editBook = async(id, data) => {
    const user = getStore('user')  
    const response =  await fetch(`/api/admin/booking/${id}`,{
        method: 'PUT',
        headers: {
        'Content-Type': 'application/json',
        'x-access-token': user.accessToken
        },
        body: JSON.stringify(data)
    });
    if (response.ok) {
        return response.json();
    }
    throw response;
}

const addBook = async(data) => {
    const user = getStore('user')  
    const response =  await fetch(`/api/admin/booking`,{
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'x-access-token': user.accessToken
        },
        body: JSON.stringify(data)
    });
    if (response.ok) {
        return response.json();
    }
    throw response;
}

const postCheckoutBook = async(data) => {
    const user = getStore('user')  
    const response =  await fetch(`/api/admin/post-checkout-booking`,{
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'x-access-token': user.accessToken
        },
        body: JSON.stringify(data)
    });
    if (response.ok) {
        return response.json();
    }
    throw response;
}

const getAllBookings = async(from, to, statuses, includeCancel) => {
    const user = getStore('user');
    if (!user) {
      throw new ValidationError('token is not found');
    }
    const statusesString = statuses.map(status=>`statuses[]=${status}&`).join('')
    statusesString.slice(0, -2)
    let url = `/api/admin/booking?from=${from}&to=${to}&${statusesString}&includeCancel=${includeCancel}`;
    const response =  await fetch(url, {
         headers: {
            'Content-Type': 'application/json',
            'x-access-token': user.accessToken
        }
    });
    if (response.ok) {
        return response.json();
    }
    throw response;
}
const getBookDetails = async(ids) => {
    const user = getStore('user');
    if (!user) {
      throw new ValidationError('token is not found');
    }
    const idString = ids.map(id=>`ids[]=${id}&`).join('')    
    idString.slice(0, -2)
    let url = `/api/admin/bookings?${idString}`;
    const response =  await fetch(url, {
         headers: {
            'Content-Type': 'application/json',
            'x-access-token': user.accessToken
        }
    });
    if (response.ok) {
        return response.json();
    }
    throw response;
}

const sendReceipt = async(id) => {
    const user = getStore('user');
    if (!user) {
      throw new ValidationError('token is not found');
    }
    const url = `/api/admin/sendReceipt/${id}`;
    const response =  await fetch(url,{
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'x-access-token': user.accessToken
        }
    });
    if (response.ok) {
        return true;
    }
    throw response;
}

const revoke = async (id) => {
    const user = getStore('user');
    if (!user) {
      throw new ValidationError('token is not found');
    }
    const response =  await fetch(`/api/admin/booking/${id}/revoke` ,{
        method: 'PUT',
        headers: {
           'Content-Type': 'application/json',
           'x-access-token': user.accessToken
       },
   });
   if (response.ok) {
        return ;
    }
    throw response;
}

const amend = async (id, from, to, billableDates, discount) => {
    const user = getStore('user');
    if (!user) {
      throw new ValidationError('token is not found');
    }
    const response =  await fetch(`/api/admin/booking/${id}/amend` ,{
        method: 'PUT',
        headers: {
           'Content-Type': 'application/json',
           'x-access-token': user.accessToken
       },
       body: JSON.stringify({from: from.utc().toISOString(), to: to.utc().toISOString(), billableDates: billableDates, discount: discount})
   });
   if (response.ok) {
        return
    }
    throw response;
}

const extend = async (id, to, billableDates, discount) => {
    const user = getStore('user');
    if (!user) {
      throw new ValidationError('token is not found');
    }
    const response =  await fetch(`/api/admin/booking/${id}/extend` ,{
        method: 'PUT',
        headers: {
           'Content-Type': 'application/json',
           'x-access-token': user.accessToken
       },
       body: JSON.stringify({to: to.utc().toISOString(), billableDates: billableDates, discount: discount})
   });
   if (response.ok) {
        return
    }
    throw response;
}

const printReceipt = async(id) => {
    const user = getStore('user');
    if (!user) {
      throw new ValidationError('token is not found');
    }
    const response =  await fetch(`/api/admin/receipt?id=${id}`, {
        headers: {
           'x-access-token': user.accessToken
       }
    });
   if (response.ok) {
        return
    }
    throw response;
}

const getProductFrequency = async (tenantId) => {
    const user = getStore('user');
    if (!user) {
      throw new ValidationError('token is not found');
    }
    const response =  await fetch(`/api/admin/user/${tenantId}/productFrequency`, {
        headers: {
           'x-access-token': user.accessToken
       }
    });
   if (response.ok) {
        return await response.json()
    }
    throw response;
}

export {
    getAllItems,
    cancelBook,
    updateStatus,
    addBook,
    getAllBookings,
    getBookDetails,
    getBookingById,
    editBook,
    sendReceipt,
    postCheckoutBook,
    completeCheckIn,
    revoke,
    amend,
    extend,
    printReceipt,
    getProductFrequency
}
